import React from 'react';
import PropTypes from 'prop-types';
import { SpacerVertical } from '@klarna/bubble-ui';
import { REGIONS } from 'moet-core/src/utils/region';

import { Header as PersonHeader } from '../PersonSummary';
import SummarySection from '../SummarySection';
import { DocumentList } from './DocumentList';

export const StakeholderDocuments = ({ region, stakeholdersWithDocuments = [], t }) =>
  stakeholdersWithDocuments.map(
    ({ id, data: { firstName, lastName } = {}, documents = [], roles = [] } = {}) =>
      documents.length > 0 && (
        <SummarySection key={id}>
          <PersonHeader
            roles={region !== REGIONS.US ? roles : []}
            t={t}
            title={`${firstName} ${lastName}`}
          />
          <SpacerVertical spaceToken="space/150" />
          <DocumentList documents={documents} />
        </SummarySection>
      ),
  );

StakeholderDocuments.propTypes = {
  region: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  stakeholdersWithDocuments: PropTypes.array,
};
